import React from 'react'
import dayjs from 'dayjs'

import './styles.css'

export default () => (
  <div id="SimpleFooter" className="wrapper">
    Copyright © {dayjs().year()} Stan Winston School. All rights reserved.
  </div>
)
